<template>
  <div class="home">
    <v-carousel
      hide-delimiters
      hide-arrows
      :left-control-icon="false"
      :right-control-icon="false"
    >
      <v-carousel-item
        v-for="(item, i) in items"
        :key="i"
        :src="item.src"
        reverse-transition="fade-transition"
        transition="fade-transition"
      ></v-carousel-item>
    </v-carousel>
    <!-- <backtohauptspeise></backtohauptspeise> -->
    <v-card>
      <v-card-title class="display-3">
        Fisch
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Search"
          single-line
          hide-details
        ></v-text-field>
      </v-card-title>
      <v-data-table
        :headers="headers"
        :items="desserts"
        :search="search"
        :items-per-page="-1"
      >
        <!-- Dieser Slot macht Texte in der Tabelle fett -->
        <template v-slot:item.speise="{ item }">
          <b>{{ item.speise }}</b>
        </template>
        <template v-slot:item.preis="{ item }">
          <b>{{ item.preis }}</b>
        </template></v-data-table
      >
    </v-card>
  </div>
</template>

<script>
// import Backtohauptspeise from './Backtohauptspeise.vue';
export default {
  // components: { Backtohauptspeise },
  name: 'Fisch',
  data() {
    return {
      items: [
        {
          src: require('../assets/images/lachssteakmithintergrund.jpg'),
        },
      ],
      search: '',
      headers: [
        {
          text: 'Nummer',
          align: 'start',
          sortable: false,
          value: 'nummer',
        },
        { text: 'Speise', value: 'speise' },
        { text: 'Allergene', value: 'allergene' },
        { text: 'Preis', value: 'preis' },
      ],
      desserts: [
        {
          nummer: '151',
          speise: 'Gegrilltes Lachssteak mit Gemüse',
          allergene: '(A, D, F, N)',
          preis: '13,40 €',
        },
        // {
        //   nummer: '152',
        //   speise: 'Gebratenes Tintenfisch nach Sichuan Art (scharf)',
        //   allergene: '(A, C, D, F, R, N)',
        //   preis: '11,30 €',
        // },
        {
          nummer: '153',
          speise: 'Gegrilltes Thunfischsteak mit Gemüse',
          allergene: '(A, D, F, N)',
          preis: '13,80 €',
        },
        // {
        //   nummer: '154',
        //   speise: 'Gegrillter Butterfisch mit Gemüse',
        //   allergene: '(A, D, F, N)',
        //   preis: '12,60 €',
        // },
        {
          nummer: '155',
          speise: 'Gebratener Fisch mit Gemüse',
          allergene: '(A, D, F, N)',
          preis: '12,60 €',
        },
        {
          nummer: '156',
          speise: 'Gebratener Lachs mit Gemüse und Teriyaki Sauce',
          allergene: '(A, D, F, N)',
          preis: '12,90 €',
        },
      ],
    };
  },
  methods: {
    top() {
      window.scrollTo(0, 0);
    },
  },
  created() {
    this.top();
  },
};
</script>

<style lang="scss" scoped></style>
